module.exports = __webpack_public_path__ + "static/media/background-ORANGE@2x-80.9f22c0ef.jpg";